var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-inline-block w-50 mt-1"},[_c('title-bread-crumb',{attrs:{"page":_vm.page,"has-route":true}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }